var map = {
	"./logo_a2a.png": 3916,
	"./logo_accenture.png": 3842,
	"./logo_acea.png": 9689,
	"./logo_anas.png": 1754,
	"./logo_arcadis.png": 8557,
	"./logo_autostrade_per_litalia.png": 3117,
	"./logo_circet.png": 7842,
	"./logo_cogepa.png": 788,
	"./logo_e_distribuzione.png": 1604,
	"./logo_enelx.png": 9333,
	"./logo_essential_ark.png": 5243,
	"./logo_fibercop.png": 5114,
	"./logo_fibraweb.png": 4347,
	"./logo_fibre_connect.png": 6256,
	"./logo_infratel_italia.png": 9138,
	"./logo_inwit.png": 4815,
	"./logo_openfiber.png": 5396,
	"./logo_public_power_corporation.png": 7887,
	"./logo_siat.png": 4821,
	"./logo_sielte.png": 8600,
	"./logo_sirti.png": 6079,
	"./logo_site.png": 681,
	"./logo_solutions30.png": 8062,
	"./logo_technosky.png": 3888,
	"./logo_telebit.png": 3642,
	"./logo_terna.png": 9623,
	"./logo_tesmec.png": 6197,
	"./logo_tim.png": 5584,
	"./logo_unareti.png": 4092,
	"./logo_unidata.png": 4814,
	"./logo_valtellina.png": 9308,
	"./logo_vodafone.png": 1259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;